<template>
  <aside class="zsidebar zshowmenu md-hide">
    <w-card
      class="menutopimg"
      image="/images/zen.jpeg"
      v-if="0"
    ></w-card>

    <w-image
      v-else
      class="menutopimg"
      width="231"
      height="100"
    >
      <w-image
        :contain="true"
        class="d-block mt2"
        src="/images/logov2.png"
        :width="125"
        :height="125"
      ></w-image>
    </w-image>

    <br><br>

    <h1 class="title5 mb3" v-if="0">
      <w-icon>fal fa-align-justify</w-icon> Menu
    </h1>

    <z-menu :menu="$page.props.menus" @submenu-clicked="scrollToTop" />

    <div class="logout-container" 
     style="display: flex; flex-direction: column; align-items: center; gap: 16px; height: 50vh; justify-content: center;">
    <template v-if="$page.props.auth.user.id == 0">
      <button @click="login" class="logout-3d">
        <span>Log Masuk</span>
        <i class="fal fa-sign-in-alt"></i>
      </button>
    </template>
    <template v-else>
      <button @click="logout" class="logout-3d">
        <span>Log Keluar</span>
        <i class="fal fa-sign-out-alt"></i>
      </button>
      <div style="display: flex; flex-direction: column; align-items: center; gap: 8px; margin-top: 10px;">
        <a :href="$route('direktori_admin')" class="logout-link" @click="scrollToTop">Senarai Admin</a>
        <a :href="$route('senarai_aiman')" class="logout-link" @click="scrollToTop">Senarai AI Man</a>
      </div>
       
    </template>
      
    </div>
  </aside>
</template>

<script>
import ZMenu from './Menu'

export default {
  components: {
    ZMenu
  },
  data: () => ({
    loaded: false,
  }),
  methods: {
    logout() {
      this.$inertia.post(route('logout'), {}, {
        replace: true
      });
    },

    login() {
      this.$inertia.visit(route('login')); 
    },
    goToSenaraiAdmin() {
      this.$inertia.visit(route('direktori_admin')); 
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  },
  mounted() {
    // Tambahkan listener untuk Inertia navigation
    this.$inertia.on('success', () => {
      this.scrollToTop();
    });
  }
}
</script>

<style>
.zsidebar {
  min-width: 230px;
  max-width: 230px;
  min-height: 100vh;
  transition: all 0.3s ease;
  z-index: 3;
  position: relative;
  overflow: hidden; 
}

.menutopimg {
  margin-left: -12px;
  margin-right: -12px;
}

.zshowmenu {
  display: block !important;
}

.zhidemenu {
  width: 0px !important;
  max-width: 0px !important;
  min-width: 0px !important;
  opacity: 0;
  padding: 0 !important;
  border-right: none;
  pointer-events: none;
  overflow: hidden;
}

.logout-3d, .admin-3d {
  position: relative;
  padding: 10px 30px;
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 5px 0 #6d65ee, 0 8px 10px rgba(0,0,0,0.2);
  transition: all 0.1s ease;
  display: flex;
  align-items: center;
  gap: 10px;
}

.logout-3d {
  background: #383388;
}

.admin-3d {
  background: #6c757d;
  box-shadow: 0 5px 0 #a0a4a8, 0 8px 10px rgba(0,0,0,0.2);
}

.logout-3d:active, .admin-3d:active {
  transform: translateY(5px);
  box-shadow: 0 2px 0 #6d65ee, 0 3px 5px rgba(0,0,0,0.2);
}

.logout-3d i, .admin-3d i {
  margin-right: 10px;
  transition: transform 0.3s ease;
}

.logout-3d:hover i, .admin-3d:hover i {
  transform: rotate(90deg);
}
</style>